import client from '.'
import { getAuthHeaders } from 'utils/requests'
import { cachedFetch } from 'utils/memoryCache'
import { CACHE_TTL } from 'utils/cacheTtl'

const PREFIX = 'clients:'

const listClients = async (nome, paginate) => {
  const config = {
    headers: getAuthHeaders(),
    params: {},
  }
  if (paginate) {
    config.params.paginate = paginate
  }
  const searchValue = String(nome || '').trim()
  if (searchValue) {
    // Remove caracteres especiais do CPF/CNPJ para comparação
    const cleanQuery = searchValue.replace(/[.\-/]/g, '')
    
    // Se parece com CPF/CNPJ (apenas números ou números com formatação)
    if (/^[\d.\-/]+$/.test(searchValue) || /^\d+$/.test(cleanQuery)) {
      config.params.cpf = cleanQuery
    } else {
      // Busca por nome
      config.params.nome = searchValue
    }
  }

  // Cache em memória para reduzir refetch ao navegar.
  // Mantemos TTL curto: buscas/autocomplete precisam responder rápido a alterações.
  const cacheKey = `${PREFIX}list:${JSON.stringify(config.params)}`

  return cachedFetch(
    cacheKey,
    async () => client.get('/list', config),
    { ttlMs: CACHE_TTL.SEARCH }
  )
}

export default listClients
